/* 24GAMEKEYS — Countdown Timer + Platform Filter JS */
(function () {
  'use strict';

  /* ── COUNTDOWN TIMER ──────────────────────────────────── */
  function initCountdowns() {
    document.querySelectorAll('[data-gk-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.gkCountdown).getTime();
      if (isNaN(end)) {
        // If no date set, count down 24 hours from now
        end = Date.now() + 24 * 60 * 60 * 1000;
      }

      function update() {
        var now  = Date.now();
        var diff = Math.max(0, end - now);
        var h    = Math.floor(diff / 3600000);
        var m    = Math.floor((diff % 3600000) / 60000);
        var s    = Math.floor((diff % 60000) / 1000);

        var hEl = el.querySelector('[data-gk-hours]');
        var mEl = el.querySelector('[data-gk-mins]');
        var sEl = el.querySelector('[data-gk-secs]');

        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');

        if (diff > 0) {
          requestAnimationFrame(function () { setTimeout(update, 1000); });
        } else {
          el.closest('.gk-deal') && (el.closest('.gk-deal').style.display = 'none');
        }
      }

      update();
    });
  }

  /* ── PLATFORM FILTER BAR ──────────────────────────────── */
  function initPlatformFilter() {
    var bar = document.querySelector('.gk-platform-bar');
    if (!bar) return;

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.gk-plat-btn');
      if (!btn) return;

      // Set active state
      bar.querySelectorAll('.gk-plat-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var platform = btn.dataset.platform || 'all';

      // Filter product cards
      document.querySelectorAll('[data-gk-platform]').forEach(function (card) {
        if (platform === 'all' || card.dataset.gkPlatform === platform) {
          card.style.display = '';
          card.style.animation = 'gk-fadein 0.3s ease forwards';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  /* ── PARALLAX HERO ─────────────────────────────────────── */
  function initParallax() {
    var bg = document.querySelector('.gk-hero__bg');
    if (!bg || window.matchMedia('(max-width: 768px)').matches) return;

    window.addEventListener('mousemove', function (e) {
      var x = (e.clientX / window.innerWidth - 0.5) * 20;
      var y = (e.clientY / window.innerHeight - 0.5) * 10;
      bg.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1.05)';
    });
  }

  /* ── PARTICLE GENERATOR ────────────────────────────────── */
  function initParticles() {
    var container = document.querySelector('.gk-hero__particles');
    if (!container) return;

    for (var i = 0; i < 20; i++) {
      var p = document.createElement('div');
      p.className = 'gk-hero__particle';
      p.style.left     = Math.random() * 100 + '%';
      p.style.width    = (Math.random() * 2 + 1) + 'px';
      p.style.height   = p.style.width;
      p.style.animationDuration  = (Math.random() * 15 + 8) + 's';
      p.style.animationDelay    = -(Math.random() * 15) + 's';
      p.style.opacity = Math.random() * 0.5 + 0.1;
      container.appendChild(p);
    }
  }

  /* ── TICKER DUPLICATE ──────────────────────────────────── */
  function initTicker() {
    var ticker = document.querySelector('.gk-ticker');
    if (!ticker) return;
    // Duplicate content for seamless loop
    ticker.innerHTML = ticker.innerHTML + ticker.innerHTML;
  }

  /* ── ADD TO CART FLASH ─────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quick-add__submit, button[name="add"]');
    if (!btn) return;
    var orig = btn.innerHTML;
    setTimeout(function () {
      if (btn.innerHTML !== orig) {
        btn.innerHTML = '✓ Added!';
        setTimeout(function () { btn.innerHTML = orig; }, 1500);
      }
    }, 300);
  });

  /* ── INIT ──────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdowns();
    initPlatformFilter();
    initParallax();
    initParticles();
    initTicker();
  });

  // CSS for fade-in animation
  var style = document.createElement('style');
  style.textContent = '@keyframes gk-fadein { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:none; } }';
  document.head.appendChild(style);

})();
